import { Col } from "antd";
import { Link } from 'react-router-dom';
import { FC } from "react";
import  inicio  from './inicio.svg';

interface IProps {
  routes: Array<routesModel>;
}

interface routesModel {
  nombre: string;
  to?: string;
}

export const BreadCrumbAdmin: FC<IProps> = ({ routes }) => {
  return (
    <Col span={24}>
      <div className="d-flex justify-content-between align-items-center bar"
        style={{
          backgroundColor: '#101c31',
          padding: '4px 24px',
          color: 'white',
          boxShadow: 'inset 0px 5px 3px #00000015',
        }}
      >
        <ol className="breadcrumb m-0"

        >
          <li className="breadcrumb-item " style={{ fontSize: '10px', fontFamily: 'Montserrat-SemiBold' }}>
            <Link to="/administrador" className="text-white">
              {/* <HomeFilled /> */}
              <img src={inicio} alt="" />
            </Link>
          </li>
          {routes &&
            routes.length > 0 &&
            routes.map((breadcrumb, i) => {
              return (
                <li key={`breadcrumb-${i}`} className="breadcrumb-item font-color-FFFFFF " style={{ fontSize: '10px',   fontFamily: 'Montserrat-Regular' }} aria-current="page">
                  {breadcrumb.to && (
                    <Link to={breadcrumb.to} className="bread-crumb text-white " style={{textDecoration: 'underline', fontFamily: 'Montserrat-Regular'}}>
                      {breadcrumb.nombre}
                    </Link>
                  )}
                  {!breadcrumb.to && breadcrumb.nombre}
                </li>
              );
            })}
        </ol>

      </div>
    </Col>

    // <Row className="background-color-101c31 width-100 padding-left-5">
    //   <Col>
    //     <Breadcrumb separator="/" className="breadcrumb-administrador">
    //       {props.routes.map((data: routesModel, index: number) => {
    //         if (index === props.routes.length - 1) {
    //           //
    //           return (
    //             <Breadcrumb.Item>
    //               {data.icon ? <span className="font-color-FFFFFF font-size-9px">{data.icon}</span> : null}
    //               <span className="font-size-9px font-color-FFFFFF font-family-Montserrat-Regular">karen{data.nombre}</span>
    //             </Breadcrumb.Item>
    //           );
    //         }
    //         return (
    //           <Breadcrumb.Item>
    //             {data.icon ? <span className="font-color-FFFFFF font-size-9px">{data.icon}</span> : null}
    //             <span className="font-size-9px font-color-FFFFFF font-family-Montserrat-Regular">{data.nombre}</span>
    //           </Breadcrumb.Item>
    //         );
    //       })}
    //     </Breadcrumb>
    //   </Col>
    // </Row>
  );
};
